import(/* webpackMode: "eager" */ "/app/src/app/(layout)/(PALayout)/layout.tsx");
